import React from "react";
import "./ECard.scss";
import InformationToolTip from "../Stat/InformationToolTip";

interface ICardProps {
  title?: string;
  header?: JSX.Element | JSX.Element[];
  children?: JSX.Element | JSX.Element[] | React.ReactNode;
  footer?: JSX.Element | JSX.Element[];
  noHeader?: boolean;
  informationToolTip?: boolean;
  toolTipLabel?: string;
  bodyClassName?: string;
}

export function ECard(props: ICardProps) {
  return (
    <div className="card" 
    style={!props.title ? 
      {
        borderRadius:'0px',
        borderWidth:'1.5px',
        borderColor:'rgb(156 163 175)'
    }:{}}
    // style={{
    //       borderRadius:'0px',
    //       borderWidth:'1.5px',
    //       borderColor:'rgb(156 163 175)'
    //   }}
      >
      <div
        className="card--head"
        style={props?.noHeader ? { display: "none" } : {}}
        // style={{
        //     borderBottom: "1px solid",
        //     borderColor: "rgb(156 163 175)",
        //     ...(props?.noHeader && { display: "none" }),
        //   }}
      >
        <div className="title flex"
             
        >
          {props.title}
          {props.informationToolTip ? (
            <InformationToolTip
              customClassName="ml-2"
              toolTipLabel={props?.toolTipLabel}
            />
          ) : null}
        </div>
        <div>{props.header}</div>
      </div>
      <div className={`card--body ${props.bodyClassName || ""}`}>
        {props.children}
      </div>
      {props.footer && <div className="card--foot">{props.footer}</div>}
    </div>
  );
}
